document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      menu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  const modal = document.querySelector('[data-health-modal]');
  const consentCheckbox = modal?.querySelector('[data-consent-checkbox]');
  const continueButton = modal?.querySelector('[data-consent-continue]');
  const cancelButtons = modal?.querySelectorAll('[data-consent-cancel]') || [];
  let pendingUrl = '';

  const closeModal = () => {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('modal-open');
    pendingUrl = '';
  };

  document.querySelectorAll('[data-health-consent]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const destination = new URL(link.href, window.location.href);
      const isProductPage = destination.origin === window.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(destination.pathname);
      if (isProductPage) return;
      if (!modal || modal.dataset.enabled !== 'true' || sessionStorage.getItem('ancientRootHealthConsent') === 'accepted') return;
      event.preventDefault();
      pendingUrl = link.href;
      modal.hidden = false;
      document.body.classList.add('modal-open');
      consentCheckbox?.focus();
    });
  });

  consentCheckbox?.addEventListener('change', () => {
    continueButton.disabled = !consentCheckbox.checked;
  });

  continueButton?.addEventListener('click', () => {
    if (!consentCheckbox?.checked) return;
    sessionStorage.setItem('ancientRootHealthConsent', 'accepted');
    const destination = pendingUrl;
    closeModal();
    if (destination) window.location.assign(destination);
  });

  cancelButtons.forEach((button) => button.addEventListener('click', closeModal));
  modal?.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
  });
});
